import DOMPurify from 'dompurify';

export const decodeAndSanitizeHtml = (html: string) => {
  // Decode the HTML string from the server
  const decoded = html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&');

  // Add attributes in anchor tag to ensure all links open in new tab with security attributes
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  // Sanitize the HTML string to prevent XSS attacks
  const sanitized = DOMPurify.sanitize(decoded, {
    ALLOWED_TAGS: ['p', 'ul', 'li', 'em', 'strong', 'b', 'u', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  });

  // Remove hook after sanitization to avoid side effects
  DOMPurify.removeHook('afterSanitizeAttributes');

  return sanitized;
};

export const decodeAndSanitizeAssessmentHtml = (html: string) => {
  // Decode the HTML string from the server
  const decoded = html
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
    // Strip literal \n (backslash + n) that the API sends as a separator between tags
    .replace(/\\n/g, '')
    // Convert misused <ul>text</ul> (no <li> children) to <li>text</li>
    .replace(/<ul>([^<]+?)<\/ul>/g, '<li>$1</li>');

  // Add attributes in anchor tag to ensure all links open in new tab with security attributes
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });

  // Sanitize the HTML string to prevent XSS attacks
  const sanitized = DOMPurify.sanitize(decoded, {
    ALLOWED_TAGS: ['p', 'ul', 'li', 'em', 'strong', 'b', 'u', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  });

  // Remove hook after sanitization to avoid side effects
  DOMPurify.removeHook('afterSanitizeAttributes');

  // Strip any \n that survived entity-decoding through DOMPurify
  return sanitized.replace(/\\n/g, '');
};

export const capitalizeFirstLetter = (str: string | undefined) => {
  if (!str || str.length === 0) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
